import store from '../index';

// initial state
const state = {
  callInfo: '',
  callStarted: false,
  updateName: '',
  callStatus: '',
  reportObj: {
    isAddedClue: 0,
    id: null
  },
  thread: false,
  closeCard: false,
  commonCallStatus: 0
};
// getters
const getters = {};

//actions
const actions = {
  getCallInfo({ commit, dispatch }, data) {
    commit('setCallInfo', data);
    return data;
  },
  getUpdateName({ commit, dispatch }, data) {
    commit('setUpdateName', data);
    return data;
  },
  getCallStatus({ commit, dispatch }, data) {
    commit('setCallStatus', data);
    return data;
  },
  getReportObj({ commit, dispatch }, data) {
    commit('setReportObj', data);
    return data;
  },
  getThread({ commit, dispatch }, data) {
    commit('setThread', data);
    return data;
  },
  getCloseCard({ commit, dispatch }, data) {
    commit('setCloseCard', data);
    return data;
  },
  getCommonCallStatus({ commit, dispatch }, data) {
    commit('setCommonCallStatus', data);
    return data;
  }
};

// mutations
const mutations = {
  setCallInfo(state, data) {
    state.callStarted = data ? true : false;
    state.callInfo = data;
  },
  setUpdateName(state, data) {
    state.updateName = data;
  },
  setCallStatus(state, data) {
    state.callStatus = data;
  },
  setReportObj(state, data) {
    state.reportObj = data;
  },
  setThread(state, data) {
    state.thread = data;
  },
  setCloseCard(state, data) {
    state.closeCard = data;
  },
  setCommonCallStatus(state, data) {
    state.commonCallStatus = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/callInfo.js